import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

// eslint-disable-next-line import/no-cycle
import { useFetch } from '../../../services/transports';
import { searchStakeholdersBySubscriptionType } from '../../../api/drug';
import { LabeledSelect } from '..';

export const SearchStakeholdersBySubscriptionDropdown = ({
  label,
  id,
  onChange,
  withAsterisks,
  disabled,
  value,
  setValueAsObject,
  subscriptionTypeId,
  subscriptionPackageId,
  ...props
}) => {
  const [ t ] = useTranslation();
  const [ options, setOptions ] = useState([]);

  const getDisplayValue = () => {
    if (!setValueAsObject) {
      return value;
    }
    if (typeof value === 'number') {
      const foundOption = options.find(opt => opt.item?.shId === value);

      return foundOption ? foundOption.value : value;
    }
    if (value?.value) {
      return value.value;
    }

    return value;
  };

  const [ { data }, fetchStakeholders ] = useFetch(
    searchStakeholdersBySubscriptionType,
    useCallback(response => {
      const container = response?.data?.container;

      return container;
    }, [])
  );

  useEffect(() => {
    if (data && Array.isArray(data)) {
      const mappedOptions = data.map(item => ({
        value: `${item.shId}`,
        text: `${item.gln} - ${item.name}`,
        item
      }));
      setOptions(mappedOptions);
    } else {
      setOptions([]);
    }
  }, [ data ]);

  const onSearch = useCallback(query => {
    if (!query?.trim()) {
      setOptions([]);

      return;
    }

    const searchParams = {
      GlnORName: query.trim()
    };

    if (subscriptionTypeId !== undefined && subscriptionTypeId !== null) {
      searchParams.subscriptionTypeId = subscriptionTypeId;
    }

    if (subscriptionPackageId !== undefined && subscriptionPackageId !== null) {
      searchParams.subscriptionPackageId = subscriptionPackageId;
    }

    fetchStakeholders(searchParams);
  }, [fetchStakeholders, subscriptionTypeId, subscriptionPackageId]);

  return (
    <LabeledSelect
      data-testid={ `${id}-stakeholders-by-subscription` }
      label={ label }
      id={ id }
      onChange={ onChange }
      showSearch={ true }
      withDebounceSearch={ true }
      onSearch={ onSearch }
      searchDelay={ 1000 }
      options={ options }
      filterOption={ false }
      EmptyComponent={ t('ERR.noMatchedSH') }
      withAsterisks={ withAsterisks }
      disabled={ disabled }
      allowClear
      value={ getDisplayValue() }
      setValueAsObject={ setValueAsObject }
      placeholder={ t('fields.choose') }
      { ...props }
    />
  );
};

